/* tslint:disable */
/* eslint-disable */
export enum BackgroundTaskStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3
}
